const Zi_2=[
    {
        "type":"Contig",
        "MAX":"50067942",
        "N10":"35655476",
        "N20":"14018733",
        "N30":"10640805",
        "N40":"7124199",
        "N50":"5142237",
        "N60":"4009817",
        "N70":"2746668",
        "N80":"1803642",
        "N90":"845365",
        "MIN":"2988"
    },
    {
        "type":"Scaffold",
        "MAX":"207019852",
        "N10":"207019852",
        "N20":"207019852",
        "N30":"108885727",
        "N40":"108278600",
        "N50":"108278600",
        "N60":"87793378",
        "N70":"81833912",
        "N80":"67613558",
        "N90":"57313525",
        "MIN":"2988"
    }
]
export default Zi_2